import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import AdditionalFeesRequests from 'app/requests/ContractBasis/ContractBasis.requests'

export default function useGetAdditionalFeesByContractBasisId({
    id, showArchived,
}: {
    id: number,
    showArchived: boolean
}) {
    return useRequestTable<{data:any}>({
        config: AdditionalFeesRequests.filterRequestAdditionalFees,
        params: {
            contractId: id,
        },
        key: RequestKeys.getContractBasisAdditionalFee,
        showArchived,
    })
}
